define(
	'C3.ShoppingExtensions.CartPage.QuickAdd.List.Cell.View',
	[
		 'SCView', 
		 'c3_shoppingextensions_cartpage_quickadd_listcell.tpl',
		 'Utils',
		 'Profile.Model',
		 'LiveOrder.Model'
		 
	],
	function(
		SCViewComponent, 
		c3_shoppingextensions_cartpage_quickadd_listcell_tpl,
		Utils,
		ProfileModel,
		LiveOrderModel
	) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function QuickAddListCellView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = c3_shoppingextensions_cartpage_quickadd_listcell_tpl;
	      this.application = options.application;
	      this.model = options.model;

       		 this.contextDataRequest = ['item'];
		}

		// Inherit parent instance methods.
		QuickAddListCellView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		QuickAddListCellView.prototype.constructor = QuickAddListCellView;


		QuickAddListCellView.prototype.getContext = function() {

			var itemQtyInCurrentOrder = 0;

			var lightboxItem = this.model.get('custitem_lightbox_item_url_component');
			var finalLightboxUrl = ''
			,   kititemonly = this.model.get('custitem_kit_item_only') 
			,   qtyAvailableInv = this.model.get('custitem_qty_available_inv')
			,   qtyAvailableKit = this.model.get('custitem_qty_available_kit')
			,   itemType = this.model.get('itemtype')
			,   enableOutOfStock = this.model.get('custitem_celigo_shopify_enable_out_sto')
			,   isWebsiteCategoryProduct = this.model.get('custitem157') 
			,   isKitItemOnly = this.model.get('custitem_kit_item_only')
			,   outOfStockDisplay = this.model.get('custitem_aa_out_of_stock_display')
            ,   showContactForPricingButton = false
            ,   showOutOfStockButton = false 
			,   showOutofStock = false;

			
			
			//console.log(keywordFromUrl[1]);

			/*if(lightboxItem !== '')
			{
				finalLightboxUrl = "/"+lightboxItem;
			}*/

			//console.log(isWebsiteCategoryProduct)

			if(outOfStockDisplay == "Out of Stock")
                showOutOfStockButton = true;
            else if(outOfStockDisplay == "Contact for Pricing")
                showContactForPricingButton = true;

			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;

			if(itemType == "Kit")
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
	                showOutOfStockButton = true;
	            	else if(outOfStockDisplay == "Contact for Pricing")
	                showContactForPricingButton = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
	                showOutOfStockButton = true;
	            	else if(outOfStockDisplay == "Contact for Pricing")
	                showContactForPricingButton = true;
				}
			}

			//console.log(qtyAvailableInv)

			var price_detail = this.model.get('onlinecustomerprice_detail');
			var relateditems_detail=_.sortBy(this.model.get('relateditems_detail'), 'custitem_aamedical_sca_sub_category'); 	
            var subCategoriesList = _.compact(_.uniq(_.pluck(relateditems_detail , 'custitem_aamedical_sca_sub_category'))); 
            
            //console.log(this.model)

            if(subCategoriesList.length > 0)
			subCategoriesList = (subCategoriesList.join()).replaceAll(','," • ")	

			var price_container_object = this.model.getPrice()
			,   pricelevel1 = this.model.get('pricelevel1')
			,   pricelevel1_formatted = this.model.get('pricelevel1_formatted')
			,   onlinecustomerprice_detail = price_detail
			,   applyStrikeThroughPrice = false
			,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
			,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,	savePrice = 0
			,	savePercent=0
			,	discountPercentage=0;

			//console.log(this.model)

			if(pricelevel1 && pricelevel1 > onlineprice)
			{
				//console.log(pricelevel1.toLocaleString('en'));
				applyStrikeThroughPrice = true;
			}

			if(pricelevel1_formatted)
				special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
			
			if(price_container_object)
			{
				onlineprice = price_container_object.price_formatted;
				//console.log(price_container_object)
				if(onlineprice)
				special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
			}	


			//console.log(pricelevel5)
            //console.log(pricelevel1)

            var currPrice = pricelevel5 || pricelevel1 || 0; 
			if( currPrice < 5){
			    showOutofStock = true;
			}   
				//console.log(this.model.getPrice())
			//using lightbox field condition instead of relateditems
			//if(subCategoriesList.length  == 0)
			/*if(lightboxItem == '')
			{*/

				var liveOrder = LiveOrderModel.getInstance();
				var self = this;
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == self.model.get('internalid');
		       	});

		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}
		       //	console.log(itemQtyInCurrentOrder)
			/*}*/

			//console.log(itemQtyInCurrentOrder)

			/*var url = '';
			if(ProfileModel.getInstance().hidePrices())
			{
				 url = Session.get('touchpoints.login') +
                '&origin=' +
                (Configuration.get('currentTouchpoint') || 'home') +
                '&origin_hash=';

                url = url +
                encodeURIComponent(this.options.origin === 'PDPQUICK'
                    ? this.model.generateURL().replace('/', '')
                    : Backbone.history.fragment);
			}*/

	       	/*if(isKitItemOnly == true)
			showOutofStock = true;*/
			
			if(applyStrikeThroughPrice)
            {
            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
            	discountPercentage = (savePrice / pricelevel1) * 100;
            	savePercent=Math.trunc(discountPercentage)+ "%";
            }
			return {
				internalid: this.model.get('internalid'),
	            // @property {String} name
	            name: this.model.get('displayname'),
	            // @property {String} url
	           /* url: this.model.get('_url'),*/
	            // @property {String} sku
	            sku: this.model.get('itemid'),
	            // @property {Boolean} isEnvironmentBrowser
	            isEnvironmentBrowser:
	                SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled,
	            // @property {ImageContainer} thumbnail
	            thumbnail: this.model.get('_thumbnail'),
	            isPhoneDevice: Utils.isPhoneDevice(),
				plpPrice : price_detail.onlinecustomerprice_formatted,
				subCategoriesList : subCategoriesList.length > 0,
				itemQtyInCurrentOrder : itemQtyInCurrentOrder,
	            itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0,
	            itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1,
	            origin : 'Cart',
	            /*lightBoxItemURL : finalLightboxUrl,*/
	            applyStrikeThroughPrice : applyStrikeThroughPrice,
				BasePriceFormatted : special_formatted_pricelevel1,
				OnlinePriceFormatted : special_formatted_pricelevel5,
				showOutofStock : showOutofStock,
				isWebsiteCategoryProduct : isWebsiteCategoryProduct,
				hidePricing: ProfileModel.getInstance().hidePrices(),
				savePrice : savePrice,
				savePercent:savePercent,
				showContactForPricingButton : showContactForPricingButton,
            	showOutOfStockButton : showOutOfStockButton,
            	serialLotFunctionality : serialLotFunctionality
			}
		}

		// Return the AMD constructor.
		return QuickAddListCellView;
	}
);
